module.exports = "pegasus/assets/blocks/column-7-theme5.png";